import React, { useEffect, useState } from "react";
import { IChartOption } from "src/shared/models/IDashboards.models";
import ReactECharts from 'echarts-for-react';
import { NoDataChart } from "./NoDataChart";

interface FormProps {
  details: IChartOption;
  titleChart: string;
  titleChartNoData: string;
  typeIcon?: boolean;
}

export const EchartBasicBarHorizontal = React.memo(({ details, titleChart, titleChartNoData, typeIcon = true }: FormProps) => {
  const chartColors = ["#79C4FF", "#B0E57C", "#FFA500"]; //#FFA500
  const [option, setOption] = useState<any>(null);

  useEffect(() => {
    if(details?.labels?.length > 0)
      loadData()
  }, [details]);

  const loadData = () => {
    const reversedLabels = details?.labels?.slice().reverse() ?? [];
    const reversedSeries = details?.series?.slice().reverse() ?? [];

    const dataInfo = 
      reversedLabels?.map((y: any, index: number) => {
        return { value: reversedSeries[index] ?? 0, name: y };
      }) || {}
    setOption(
    {
      title : {
        text: titleChart,
        subtext: "",//'subtitulo'
        x:'left',
        y: 20,
        textStyle: {
          fontSize: 16,
          fontFamily: 'Open Sans,sans-serif',
        },
      },
      color: chartColors,
      tooltip : {
        trigger: 'item',
        formatter: "{b} : {c}"
      },
      // grid: {
      //   left: '20%', // Ajusta este valor para dejar más espacio a la izquierda
      //   // bottom: '10%',
      //   containLabel: false
      // },
      yAxis: {
        type: 'category',
        data: reversedLabels ?? [],
        axisLabel: {
          fontFamily: 'Open Sans,sans-serif',
          fontSize: 9, // Ajusta el tamaño de la fuente aquí
          overflow: 'truncate', // Trunca el texto que se pasa del límite
          width: 50, // Ajusta el ancho máximo del label
          formatter: function (value: string) {
            const maxLength = 6; // Máximo número de caracteres
            if (value.length > maxLength) {
              return value.substring(0, maxLength) + '...'; // Trunca y añade '...'
            }
            return value;
          }
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed'
          }
        },
        
      },
      xAxis: {
        type: 'value' ,
        splitLine: {
          show: false,
        }
      },
      series : [
        {
          name: titleChart,
          type: "bar",
          data: dataInfo,
          fontFamily: 'Open Sans,sans-serif',
          // barWidth: '90%', // Ajusta el ancho de las barras
          itemStyle: {
            fontFamily: 'Open Sans,sans-serif',
            emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          label: {
            show: true,
            position: 'insideRight', // Muestra las etiquetas dentro de las barras
            align: 'right', // Alinear las etiquetas a la derecha
            formatter: '{c}', // Muestra el valor de la barra
            color: '#fff', // Color del texto
            fontWeight: 'bold',
            fontSize: 9,
            fontFamily: 'Open Sans,sans-serif'
          }
        }
      ]
    })
  }

  if (!option && details?.labels?.length > 0) return <></>;

  return (
    <>
    {
    details?.labels?.length > 0 ? 
      <ReactECharts
        option={option}
        style={{ height: 200 }}
        // style={{ height: 300 }}
        onEvents={{
          // 'click': onChartClick,
          // 'legendselectchanged': onChartLegendselectchanged
        }}
        />
      : <NoDataChart titleChart={titleChart} titleChartNoData={titleChartNoData} typeIcon={typeIcon} mBottom={"30px"} />
    }
    </>
  );
});